var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3a.75.75 0 0 1 .75.75v.75h7.5v-.75a.75.75 0 0 1 1.5 0v.75H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3h.75v-.75A.75.75 0 0 1 7.5 3Zm8.25 3v.75a.75.75 0 0 0 1.5 0V6H18a1.5 1.5 0 0 1 1.5 1.5V9h-15V7.5A1.5 1.5 0 0 1 6 6h.75v.75a.75.75 0 0 0 1.5 0V6h7.5ZM4.5 10.5V18A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5v-7.5h-15Z"
  })));
};
export default SvgCalendar;